import type {TicketStatus} from '../types/ticket';

/**
 * The order a queue is read in, and therefore the order a status menu offers.
 *
 * Named once so the list's grouping and the Details panel's menu can never disagree
 * about which status comes first.
 */
export const STATUS_ORDER: readonly TicketStatus[] = ['open', 'in_progress', 'waiting_on_customer', 'resolved', 'closed'];
